/* eslint-disable no-new */
/* eslint-disable no-unused-vars */
import Flickity from 'flickity';

const carousels = Array.from(document.querySelectorAll('.js-carousel'));
const carouselTouch = Array.from(document.querySelectorAll('.js-carousel-touch'));

let flickity;

if (carousels) {
    carousels.forEach((carousel) => {
        const flickity = new Flickity(carousel, {
            cellAlign: 'center',
            groupCells: false,
            prevNextButtons: false,
            pageDots: true,
            autoPlay: false,
            wrapAround: false,
            draggable: true,
            contain: true,
            watchCSS: true
        });
    });
}
